import React, {PureComponent} from 'react';
import GlobalHeader from 'eventbrite_design_system/globalHeader/GlobalHeader';
import {
    getLogoInfo,
    getNonUserQuickLinks,
    getUserMenuInfo
} from '@eb/site-header';
import {
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE
} from '@eb/site-structure';
import {gettext} from '../../translations';

import EventbriteAppMarketplaceLogo from '../../svgs/eventbrite-app-marketplace-logo.svg';

export default class CustomGlobalHeader extends PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
    }

    _getQuickLinks(env, user) {
        let quickLinks = [];

        if (user.isAuthenticated) {
            quickLinks.push({
                url: `${env.serverUrl}/organizations/extensions/`,
                content: <span className="eds-text-weight--heavy">{gettext('Manage apps')}</span>,
            });
        }

        return quickLinks;
    }

    render() {
        const {
            env,
            request,
            user,
        } = this.props;

        const userMenuInfo = {
            serverUrl: env.serverUrl,
            adminServerUrl: env.adminServerUrl,
            logoutUrl: env.logoutUrl,
            requestPath: request.path,
            user,
            isNewAccountSettingsActive: user.isNewAccountSettingsActive,
            showBrowseEvents: false,
        };

        let logoInfo = getLogoInfo(env.serverUrl, request.path);
        
        logoInfo.url = `${env.serverUrl}/apps/`;
        logoInfo.iconType = <img src={EventbriteAppMarketplaceLogo} alt="Eventbrite App Marketplace" />;

        return (
            <GlobalHeader 
                logoInfo={logoInfo} 
                userMenuInfo={getUserMenuInfo(userMenuInfo)}
                quickLinks={this._getQuickLinks(env, user)}
                nonUserQuickLinks={getNonUserQuickLinks(request.path, user.isAuthenticated, env.loginUrl)}
            />
        );
    }
    
}


// WEBPACK FOOTER //
// ./src/components/CustomGlobalHeader/CustomGlobalHeader.js